import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Inviteus from "../../assests/invite_us.jpg";

function InviteUs() {
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    lastName: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const payload = {
      _subject: `Invitation Request from ${formData.title} ${formData.firstName} ${formData.lastName}`.trim(),
      _captcha: "false",
      Title: formData.title,
      "First Name": formData.firstName,
      "Last Name": formData.lastName,
      Street: formData.street,
      City: formData.city,
      State: formData.state,
      "Zip Code": formData.zip,
      Email: formData.email,
      Phone: formData.phone,
      Message: formData.message,
    };

    console.log("=== FORM SUBMISSION START ===");
    console.log("PAYLOAD SENT:", payload);

    try {
      const response = await fetch("https://formsubmit.co/ajax/cfimin@christforindia.org", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("SERVER RESPONSE STATUS:", response.status);
      console.log("SERVER RESPONSE BODY:", result);
      console.log("=== FORM SUBMISSION END ===");

      if (response.ok) {
        alert(`Mail status: ${result.message || "Sent successfully!"}\nCheck browser console for full payload & response details.`);
        setFormData({
          title: "",
          firstName: "",
          lastName: "",
          street: "",
          city: "",
          state: "",
          zip: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        alert(`FormSubmit Error: ${result.message || "Failed to send"}\nCheck console for details.`);
      }
    } catch (error) {
      console.error("FORM SUBMIT ERROR:", error);
      alert("Error sending email: " + error.message);
    } finally {
      setSubmitting(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #cfcfcf",
    fontSize: "13px",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "Arial, sans-serif",
  };

  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        background: "#fff",
        color: "#222",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "0 1.5rem 4rem",
        }}
      >
        {/* Back */}
        <Link
          to="/"
          style={{
            fontSize: "13px",
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            margin: "1.5rem 0 0",
            userSelect: "none",
          }}
        >
          ← Back to Home
        </Link>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            fontSize: "2.5rem",
            color: "#e67b22",
            margin: "1rem 0 0.2rem",
            fontWeight: "700",
          }}
        >
          Invite Us
        </h1>

        <div
          style={{
            display: "flex",
            gap: "4px",
            marginBottom: "2rem",
          }}
        >
          {[...Array(9)].map((_, i) => (
            <div
              key={i}
              style={{
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                background: "#e67b22",
              }}
            />
          ))}
        </div>

        {/* Image & Description */}
        <div
          style={{
            display: "flex",
            gap: "2rem",
            alignItems: "flex-start",
            flexWrap: "wrap",
            marginBottom: "2.5rem",
          }}
        >
          <div style={{ flex: "0 0 340px" }}>
            <img
              src={Inviteus}
              alt="Invite Us"
              style={{
                width: "100%",
                display: "block",
              }}
            />
          </div>

          <div
            style={{
              flex: 1,
              minWidth: "260px",
            }}
          >
            <p
              style={{
                fontSize: "13px",
                lineHeight: "1.9",
                color: "#333",
                marginTop: "2rem",
              }}
            >
              If you would like a representative to come to your small
              group, church, or business to share about opportunities
              to serve, Jameson and the CFI board will be happy to come
              speak, preach, and share to your group!
            </p>
          </div>
        </div>

        {/* Contact Heading */}
        <h3
          style={{
            fontSize: "17px",
            fontWeight: "500",
            marginBottom: "1.4rem",
          }}
        >
          Contact Rev. Jameson P. Titus
        </h3>

        <form onSubmit={handleSubmit}>
          {/* Radio Buttons */}
          <div
            style={{
              display: "flex",
              gap: "18px",
              marginBottom: "1.5rem",
              flexWrap: "wrap",
              fontSize: "13px",
            }}
          >
            {["Mr.", "Mrs.", "Ms.", "Dr.", "Rev."].map((title) => (
              <label
                key={title}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <input
                  type="radio"
                  name="title"
                  value={title}
                  checked={formData.title === title}
                  onChange={handleChange}
                />
                {title}
              </label>
            ))}
          </div>

          {/* Row 1 */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "15px",
              marginBottom: "14px",
            }}
          >
            <input
              style={inputStyle}
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleChange}
            />

            <input
              style={inputStyle}
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
            />
          </div>

          {/* Row 2 */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "15px",
              marginBottom: "14px",
            }}
          >
            <input
              style={inputStyle}
              type="text"
              name="street"
              placeholder="Street"
              value={formData.street}
              onChange={handleChange}
            />

            <input
              style={inputStyle}
              type="text"
              name="city"
              placeholder="City"
              value={formData.city}
              onChange={handleChange}
            />
          </div>

          {/* Row 3 */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "15px",
              marginBottom: "14px",
            }}
          >
            <input
              style={inputStyle}
              type="text"
              name="state"
              placeholder="State"
              value={formData.state}
              onChange={handleChange}
            />

            <input
              style={inputStyle}
              type="text"
              name="zip"
              placeholder="Zip Code"
              value={formData.zip}
              onChange={handleChange}
            />
          </div>

          {/* Row 4 */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "15px",
              marginBottom: "14px",
            }}
          >
            <input
              style={inputStyle}
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
            />

            <input
              style={inputStyle}
              type="text"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          {/* Message */}
          <textarea
            style={{
              ...inputStyle,
              minHeight: "110px",
              resize: "vertical",
              marginBottom: "1.8rem",
            }}
            placeholder="Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
          />

          {/* Button */}
          <button
            type="submit"
            disabled={submitting}
            style={{
              background: submitting ? "#aaa" : "#f58220",
              color: "#fff",
              border: "none",
              padding: "11px 22px",
              fontSize: "12px",
              fontWeight: "700",
              cursor: submitting ? "not-allowed" : "pointer",
              letterSpacing: "0.5px",
            }}
          >
            {submitting ? "SENDING..." : "SEND"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default InviteUs;
